import { render, staticRenderFns } from "./archivesStudentList.vue?vue&type=template&id=54b20be8&scoped=true"
import script from "./archivesStudentList.vue?vue&type=script&lang=js"
export * from "./archivesStudentList.vue?vue&type=script&lang=js"
import style0 from "./archivesStudentList.vue?vue&type=style&index=0&id=54b20be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b20be8",
  null
  
)

export default component.exports